import { Button } from 'src/components';
import styled, { css } from 'styled-components';

export const EvolutiveChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px 8px 16px;
  gap: 8px;
`;

export const Title = styled.h4`
  overflow: hidden;
  color: ${(props) => props.theme.colors.constrat};
  text-overflow: ellipsis;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 2px;
`;

export const Text = styled(Title)`
  padding-bottom: 0;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const RadiusButton = styled(Button)`
  cursor: pointer;

  ${({ disabled }) => disabled ? css`
    pointer-events: none;
  ` : ''}

  padding: 0px;
  height: 20px;
  width: 20px;
  margin-right: 2px;
  background-color: transparent;

  &:hover {
    background-color: transparent;
    color: transparent;
  }
`;

export const Circle = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid
    ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
  display: inline-block;
  background: none;
  box-sizing: border-box;
  padding: 1px;
  position: relative;

  :after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 6px;
    height: 6px;
    position: absolute;
    left: calc(50% - 3px);
    top: calc(50% - 3px);
    background: ${(props) =>
    props.isChecked ? props.theme.colors.secondary : "transparent"};
  }
`;

export const Square = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 2.28571px;
  border: 1px solid
    ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
  display: inline-block;
  background: ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : 'transparent'};
  box-sizing: border-box;
  position: relative;

  ${(props) =>
    props.isChecked
      ? `
    :before,
  :after {
    content: "";
    position: absolute;
    display: block;
    height: 9px;
    width: 1.6px;
    background: ${props.theme.colors.backgroundColorPage};
  }

  :after {
    transform: rotate(45deg);
    left: 8px;
    top: 2px;
  }
  :before {
    height: 6px;
    transform: rotate(-45deg);
    left: 4px;
    top: 5px;
  }
  `
      : ""}
`;